import {
  GET_COMPONENTS_REQUEST,
  GET_COMPONENTS_SUCCESS,
  GET_COMPONENTS_FAILURE,
} from "./componentsClientsTypes";

const initialState = {
  loading: false,
  components: [],
  error: "",
};

const getComponentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPONENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPONENTS_SUCCESS:
      return {
        loading: false,
        components: action.payload,
        error: "",
      };
    case GET_COMPONENTS_FAILURE:
      return {
        loading: false,
        components: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getComponentsReducer };
